// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__14DDb","Button_element":"Button_Button_element__3LbIm","LinkMore_item":"Button_LinkMore_item__2REJa"};